module.exports = [
	{
		"order": 1,
		"category": "people",
		"category_label": "Smileys & People"
	},
	{
		"order": 2,
		"category": "nature",
		"category_label": "Animals & Nature"
	},
	{
		"order": 3,
		"category": "food",
		"category_label": "Food & Drink"
	},
	{
		"order": 4,
		"category": "activity",
		"category_label": "Activity"
	},
	{
		"order": 5,
		"category": "travel",
		"category_label": "Travel & Places"
	},
	{
		"order": 6,
		"category": "objects",
		"category_label": "Objects"
	},
	{
		"order": 7,
		"category": "symbols",
		"category_label": "Symbols"
	},
	{
		"order": 8,
		"category": "flags",
		"category_label": "Flags"
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/emojione/categories.json
// module id = 1568
// module chunks = 2